import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  IconButton,
  Link as MuiLink,
} from "@mui/material";

import SendIcon from "@mui/icons-material/Send";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

import logo from "../../Assets/logo.png";

const Footer = () => {
  return (
    <>
      <style>{`
        .footer-wrapper {
          position: relative;
          background-image: url("https://html.themehour.net/kleanix/demo/assets/img/bg/footer_bg_1.jpg");
          background-size: cover;
          background-position: center;
          color: #ffffff;
          overflow: hidden;
        }

        /* FLOATING SHAPES */
        .shape-mockup {
          position: absolute;
          z-index: 1;
        }

        .footer-shape-1 {
          top: 120px;
          left: 80px;
        }

        .footer-shape-2 {
          bottom: 180px;
          right: 60px;
        }

        .jump {
          animation: jump 3.5s infinite ease-in-out;
        }

        .jump-reverse {
          animation: jumpReverse 3.5s infinite ease-in-out;
        }

        @keyframes jump {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-16px); }
        }

        @keyframes jumpReverse {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(16px); }
        }

        /* TOP LOGO AREA */
        .footer-top {
          padding: 70px 0 50px;
          border-bottom: 1px solid rgba(255,255,255,0.15);
          position: relative;
          z-index: 2;
        }

        .footer-logo-wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 20px;
        }

        .footer-social a {
          color: #ffffff;
          margin-left: 14px;
        }

        /* WIDGET AREA */
        .widget-area {
          padding: 80px 0;
          position: relative;
          z-index: 2;
        }

        .footer-widget {
          margin-bottom: 30px;
        }

        .widget-title {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 20px;
        }

        /* CONTACT */
        .info-box {
          display: flex;
          gap: 14px;
          margin-bottom: 16px;
        }

        .info-box-icon {
          width: 36px;
          height: 36px;
          background: rgba(255,255,255,0.12);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .footer-info-title {
          font-size: 15px;
          font-weight: 700;
          margin-bottom: 2px;
        }

        .info-text {
          font-size: 14px;
          color: rgba(255,255,255,0.75);
        }

        /* MENU */
        .footer-menu {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-menu li {
          margin-bottom: 10px;
        }

        .footer-menu a {
          color: rgba(255,255,255,0.75);
          text-decoration: none;
          font-size: 15px;
        }

        .footer-menu a:hover {
          color: #ffffff;
        }

        /* NEWSLETTER */
        .newsletter-text {
          color: rgba(255,255,255,0.75);
          margin-bottom: 14px;
        }

        .newsletter-form {
          display: flex;
          gap: 10px;
          margin-bottom: 20px;
        }

        .newsletter-form input {
          background: #ffffff;
          border-radius: 999px;
        }

        .newsletter-btn {
          background: #7ac142;
          color: #fff;
          width: 44px;
          height: 44px;
        }

        .newsletter-bottom {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: rgba(255,255,255,0.75);
        }

        /* COPYRIGHT */
        .copyright-wrap {
          border-top: 1px solid rgba(255,255,255,0.15);
          padding: 20px 0;
          text-align: center;
        }

        .copyright-text {
          font-size: 14px;
          color: rgba(255,255,255,0.7);
        }
      `}</style>

      <Box className="footer-wrapper">
        {/* FLOATING SHAPES */}
        <Box className="shape-mockup footer-shape-1 jump-reverse">
          <img src="https://html.themehour.net/kleanix/demo/assets/img/icon/footer-shape-1.png" alt="" />
        </Box>
        <Box className="shape-mockup footer-shape-2 jump-reverse">
          <img src="https://html.themehour.net/kleanix/demo/assets/img/icon/footer-shape-2.png" alt="" />
        </Box>

        {/* TOP */}
        <Box className="footer-top">
          <Container>
            <Box className="footer-logo-wrap">
              <img src={logo} alt="Logo" style={{height:"75px",width:"150px"}}/>
              <Box className="footer-social">
                <MuiLink href="#"><FacebookIcon /></MuiLink>
                <MuiLink href="#"><TwitterIcon /></MuiLink>
                <MuiLink href="#"><LinkedInIcon /></MuiLink>
                <MuiLink href="#"><InstagramIcon /></MuiLink>
              </Box>
            </Box>
          </Container>
        </Box>

        {/* WIDGETS */}
        <Box className="widget-area">
          <Container>
            <Grid container spacing={4} justifyContent="space-between">

              {/* CONTACT */}
              <Grid item xs={12} md={6} xl="auto">
                <Box className="footer-widget">
                  <Typography className="widget-title">Contact Us</Typography>

                  <Box className="info-box">
                    <Box className="info-box-icon"><LocationOnIcon /></Box>
                    <Box>
                      <Typography className="footer-info-title">Address</Typography>
                      <Typography className="info-text">
                        77815 Hartmann Plaza Suite 202, Idaho, USA
                      </Typography>
                    </Box>
                  </Box>

                  <Box className="info-box">
                    <Box className="info-box-icon"><PhoneIcon /></Box>
                    <Box>
                      <Typography className="footer-info-title">Call Us</Typography>
                      <Typography className="info-text">+163 3654 9874</Typography>
                    </Box>
                  </Box>

                  <Box className="info-box">
                    <Box className="info-box-icon"><EmailIcon /></Box>
                    <Box>
                      <Typography className="footer-info-title">Email Us</Typography>
                      <Typography className="info-text">info@kleanix.com</Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* QUICK LINKS */}
              <Grid item xs={12} md={6} xl="auto">
                <Box className="footer-widget">
                  <Typography className="widget-title">Quick Links</Typography>
                  <ul className="footer-menu">
                    <li><MuiLink href="/about">About Us</MuiLink></li>
                    <li><MuiLink href="/services">Our Services</MuiLink></li>
                    <li><MuiLink href="/faq">Faq's</MuiLink></li>
                    <li><MuiLink href="/privacy-policy">Privacy Policy</MuiLink></li>
                    <li><MuiLink href="/portfolio">Portfolio</MuiLink></li>
                    <li><MuiLink href="/contact-us">Contact Us</MuiLink></li>
                  </ul>
                </Box>
              </Grid>

              {/* SERVICES */}
              <Grid item xs={12} md={6} xl="auto">
                <Box className="footer-widget">
                  <Typography className="widget-title">Our Services</Typography>
                  <ul className="footer-menu">
                    <li><MuiLink href="#">Basement Plumbing</MuiLink></li>
                    <li><MuiLink href="#">Drain Plumbing</MuiLink></li>
                    <li><MuiLink href="#">Water Line Repair</MuiLink></li>
                    <li><MuiLink href="#">Kitchen Plumbing</MuiLink></li>
                    <li><MuiLink href="#">Gas Line Services</MuiLink></li>
                    <li><MuiLink href="#">Bathroom Services</MuiLink></li>
                  </ul>
                </Box>
              </Grid>

              {/* NEWSLETTER */}
              <Grid item xs={12} md={6} xl="auto">
                <Box className="footer-widget">
                  <Typography className="widget-title">Newsletter</Typography>
                  <Typography className="newsletter-text">
                    Subscribe to our Newsletter
                  </Typography>

                  <Box className="newsletter-form">
                    <TextField
                      fullWidth
                      placeholder="Enter Email"
                      size="small"
                    />
                    <IconButton className="newsletter-btn">
                      <SendIcon />
                    </IconButton>
                  </Box>

                  <Box className="newsletter-bottom">
                    <AccessTimeIcon fontSize="small" />
                    Monday to Saturday: 9AM - 8PM Sunday Closed
                  </Box>
                </Box>
              </Grid>

            </Grid>
          </Container>
        </Box>

        {/* COPYRIGHT */}
        <Box className="copyright-wrap">
          <Container>
            <Typography className="copyright-text">
              © 2025 Kleanix. All Rights Reserved.
            </Typography>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
